// extracted by mini-css-extract-plugin
module.exports = {"BrandsItem":"BrandsItem_BrandsItem__2X1Ka"};